/* Crafted Zone — reliable cart quantity updates for the unpublished draft theme. */
(() => {
  const applyFix = () => {
    const CartItemsElement = customElements.get('cart-items');
    if (!CartItemsElement || CartItemsElement.prototype.__czQuantityUpdateFixed) return Boolean(CartItemsElement);

    const prototype = CartItemsElement.prototype;
    prototype.__czQuantityUpdateFixed = true;

    prototype.getSectionInnerHTML = function (html, selector) {
      if (typeof html !== 'string' || !html.trim()) return null;

      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const sourceElement = selector ? documentFragment.querySelector(selector) : documentFragment.body;
      return sourceElement ? sourceElement.innerHTML : null;
    };

    prototype.updateLiveRegions = function (line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const errorText = lineItemError?.querySelector('.cart-item__error-text');
      if (errorText) errorText.textContent = message || '';

      const lineItemStatus =
        document.getElementById('shopping-cart-line-item-status') ||
        document.getElementById('CartDrawer-LineItemStatus') ||
        this.lineItemStatusElement;
      if (lineItemStatus) lineItemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus =
        document.getElementById('cart-live-region-text') ||
        document.getElementById('CartDrawer-LiveRegionText');
      if (!cartStatus) return;

      cartStatus.setAttribute('aria-hidden', 'false');
      window.setTimeout(() => cartStatus.setAttribute('aria-hidden', 'true'), 1000);
    };

    prototype.updateQuantity = async function (line, quantity, name, variantId) {
      const globalError = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (globalError) globalError.textContent = '';

      this.enableLoading(line);

      const quantityBeforeUpdate =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const previousQuantity = quantityBeforeUpdate?.getAttribute('value');
      const itemCountBeforeUpdate = document.querySelectorAll('.cart-item').length;
      const sectionsToRender = this.getSectionsToRender();

      const body = JSON.stringify({
        line,
        quantity,
        sections: sectionsToRender.map((section) => section.section),
        sections_url: window.location.pathname,
      });

      try {
        const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body });
        const responseText = await response.text();
        let parsedState;

        try {
          parsedState = JSON.parse(responseText);
        } catch (error) {
          throw new Error('Shopify returned an invalid cart response.');
        }

        if (!response.ok || parsedState.errors) {
          if (quantityBeforeUpdate && previousQuantity !== null) quantityBeforeUpdate.value = previousQuantity;
          this.updateLiveRegions(line, parsedState.errors || window.cartStrings.error);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        for (const section of sectionsToRender) {
          const sectionHtml = parsedState.sections?.[section.section];
          if (typeof sectionHtml !== 'string' || !sectionHtml.trim()) continue;

          const targetRoot = document.getElementById(section.id);
          if (!targetRoot) continue;

          const targetElement = targetRoot.querySelector(section.selector) || targetRoot;
          const replacementHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
          if (replacementHtml === null) continue;

          targetElement.innerHTML = replacementHtml;
        }

        const updatedValue = parsedState.items?.[Number(line) - 1]?.quantity;
        const currentQuantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        let message = '';

        if (
          itemCountBeforeUpdate === (parsedState.items?.length || 0) &&
          typeof updatedValue !== 'undefined' &&
          Number(updatedValue) !== Number(quantity)
        ) {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }

        if (typeof updatedValue === 'undefined' && parsedState.item_count > 0 && currentQuantityElement) {
          message = window.cartStrings.error;
        }

        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        const focusTarget = lineItem
          ? Array.from(lineItem.querySelectorAll('[name]')).find((element) => element.getAttribute('name') === name)
          : null;

        if (focusTarget) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, focusTarget) : focusTarget.focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          const emptyDrawer = cartDrawerWrapper.querySelector('.drawer__inner-empty');
          const emptyDrawerLink = cartDrawerWrapper.querySelector('a');
          if (emptyDrawer && emptyDrawerLink) trapFocus(emptyDrawer, emptyDrawerLink);
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          const firstCartItemName = document.querySelector('.cart-item__name');
          if (firstCartItemName) trapFocus(cartDrawerWrapper, firstCartItemName);
        }

        if (globalError) globalError.textContent = '';
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId,
        });
      } catch (error) {
        console.error('Crafted Zone cart quantity update failed:', error);
        const errorContainer =
          document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errorContainer) errorContainer.textContent = window.cartStrings.error;
      } finally {
        this.disableLoading(line);
      }
    };

    return true;
  };

  if (!applyFix()) {
    customElements.whenDefined('cart-items').then(applyFix);
  }
})();
